// 3-dot action dropdown per table row - View Profile, Edit, Assign Vessel, Assign Clinic, Contact, Delete
import React from 'react';
import { MoreHorizontal, User, Edit, Anchor, Building2, Mail, Trash2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from 'components/ui/dropdown-menu';

const MemberActionMenu = ({
  emp,
  onViewProfile,
  onEdit,
  onAssignVessel,
  onAssignClinic,
  onContact,
  onDelete,
  hasEditRights,
}) => {
  if (!hasEditRights) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="tw-inline-flex tw-items-center tw-justify-center tw-h-8 tw-w-8 tw-rounded-md tw-border-0 tw-bg-transparent tw-cursor-pointer hover:tw-bg-accent"
          aria-label="Member actions"
        >
          <MoreHorizontal className="tw-h-4 tw-w-4 tw-text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw-w-48">
        <DropdownMenuItem onClick={() => onViewProfile && onViewProfile(emp)}>
          <User className="tw-mr-2 tw-h-4 tw-w-4" />
          View Profile
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onEdit(emp)}>
          <Edit className="tw-mr-2 tw-h-4 tw-w-4" />
          Edit Member
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onAssignVessel && onAssignVessel(emp)}>
          <Anchor className="tw-mr-2 tw-h-4 tw-w-4" />
          Assign Vessel
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onAssignClinic && onAssignClinic(emp)}>
          <Building2 className="tw-mr-2 tw-h-4 tw-w-4" />
          Assign Medical Clinic
        </DropdownMenuItem>
        {/* TODO: re-enable Contact when feature is ready */}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="tw-text-red-600 focus:tw-text-red-600"
          onClick={() => onDelete && onDelete(emp)}
        >
          <Trash2 className="tw-mr-2 tw-h-4 tw-w-4" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MemberActionMenu;
